import request from '@/utils/request'

let PushApi = {
  /*发送推送消息*/
  send(data) {
    return request._post('/shop/plus.market.article/index', data);
  },
  /*包邮设置*/
  shipping(data) {
    return request._post('/shop/plus.market.article/index', data);
  },
  /*获取用户*/
  getList(data) {
    return request._post('/shop/plus.market.article/index', data);
  },
}
export default PushApi;



// WEBPACK FOOTER //
// ./src/api/push.js